import axios from 'axios'
import { variantUrl, getHeader } from '@/config'

const state = {
  variantList: []
}

const mutations = {
  SET_VARIANT_LIST (state, obj) {
    state.variantList = obj
  }
}

const actions = {
  getVariantList: ({ commit }) => {
    axios.get(variantUrl, { headers: getHeader() })
      .then(response => {
        commit('SET_VARIANT_LIST', response.data.data)
      })
  }
}

export default {
  state, mutations, actions
}
